const items = [
  { text: 'Login', href: '/login' },
  { text: 'Registration', href: '/register' },
];

export default items;
